// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_c2Z","cls2":"SimplePaperPodcast-cls2_wRV SimplePaperPodcast-cls1_c2Z"};